import React, { useRef } from "react";
import "./Carousel.css"; // 引入样式文件
import "./CarouselMedium.css"; // 引入样式文件
import leftArrow from "../../assets/images/home/arrowleft.png";
import rightArrow from "../../assets/images/home/arrowright.png";

const testimonials = [
  {
    name: "Yuxuan Z.",
    role: "Animator",
    text: "IKI AI helps me practice Japanese—it feels like I truly have a Japanese friend! I also love this fun and engaging approach to language learning. It's such an enjoyable way to improve my skills!",
    avatar: require("../../assets/images/customAvatars/a1.webp"), // 替换为实际头像 URL
  },
  {
    name: "Alex C.",
    role: "Corporate Employee",
    text: "The simulated scenarios are fantastic! They help me pick up more natural expressions and seamlessly apply them in my work.",
    avatar: require("../../assets/images/customAvatars/a2.webp"), // 替换为实际头像 URL
  },
  {
    name: "Rina C.",
    role: "YouTuber",
    text: "I'm planning to travel to Japan next year, so I'm learning Japanese now. IKI AI has taught me so many practical expressions—I feel confident I'll handle my trip with ease. Thank you so much!",
    avatar: require("../../assets/images/customAvatars/a3.webp"), // 替换为实际头像 URL
  },
];

const Carousel = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = current.offsetWidth; // 滚动一个卡片宽度
      current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="carousel-container">
      <div className="carousel">
        <button
          className="arrow left"
          style={{ backgroundImage: `url(${leftArrow})` }}
          onClick={() => scroll("left")}
        ></button>
        <div className="carousel-track" ref={scrollRef}>
          {testimonials.map((item, index) => (
            <div className="carousel-card" key={index}>
              <div className="avatar-wrapper">
                <img className="avatar" src={item.avatar} alt={item.name} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <span className="name" style={{ marginBottom: "2px" }}>
                    {item.name}
                  </span>
                  <span className="role">{item.role}</span>
                </div>
              </div>

              <p className="text">{item.text}</p>
            </div>
          ))}
        </div>
        <button
          className="arrow right"
          style={{ backgroundImage: `url(${rightArrow})` }}
          onClick={() => scroll("right")}
        ></button>
      </div>
    </div>
  );
};

export default Carousel;
